import { Injectable } from "@angular/core";
import { BaseHttpService } from "../base-http.service";
import { UserService } from "../user/user.service";
import { HttpClient } from "@angular/common/http";
import { MessageService } from "../../modules/shared/message/message.service";
import { ProgressBarService } from "../../modules/shared/progress-bar/progress-bar.service";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class UserCombiService extends BaseHttpService {

  constructor(protected http: HttpClient,
              protected userService: UserService,
              protected translateService: TranslateService,
              protected progressBarService: ProgressBarService,
              protected messageService: MessageService) {
    super(http, userService, translateService, progressBarService, messageService);
  }

  async run(userCombiID: number): Promise<void> {
    await this.get<void>(`authenticated/usercombi/run/${userCombiID}`);
  }

  async calculateQueueSize(userCombiID: number): Promise<number> {
    return (await this.get<number>(`authenticated/usercombi/${userCombiID}/queue`)).result;
  }
}
